<template>
  <base-card>
    <div class="tw-flex tw-flex-col">
      <h3 class="tw-text-gray-700 tw-text-lg tw-font-thin tw-whitespace-nowrap tw-mb-5">Active Plans <span class="tw-text-sm">(by group)</span></h3>
      <div class="chart-container tw-self-center">
        <div v-if="isLoading" class="tw-bg-gray-200 tw-animate-pulse tw-rounded-full tw-h-80 tw-w-80" />
        <doughnut-chart v-else :chart-data="planGroupChartData" :options="chartOptions" style="height: 20rem" />
      </div>
    </div>
  </base-card>
</template>

<script>
import DoughnutChart from "@/components/charts/DoughnutChart";
import { mapGetters } from "vuex";

export default {
  name: "PlanCountsByGroup",
  components: { DoughnutChart },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      planCounts: [],
      isLoading: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization", "cobrandId"]),
    isMobile() {
      return this.windowWidth <= 768;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        legend: {
          display: this.isMobile === true ? false : true,
          position: "bottom",
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let label = data.labels[tooltipItem.index] || "";

              if (label) {
                label += ": ";
              }
              label += `${data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]}`;
              return label;
            },
          },
        },
      };
    },

    planGroupChartData() {
      if (this.planCounts.length == 0)
        return {
          labels: ["No plans"],
          datasets: [
            {
              label: "Plan Group",
              data: [1],
              borderColor: "#cccccc", // secondary
              borderWidth: 1,
              backgroundColor: ["#ffffff"],
            },
          ],
        };
      else
        return {
          labels: this.planCounts.map((planGroup) => planGroup.planGroup),
          datasets: [
            {
              label: "Plan Group",
              data: this.planCounts.map((planGroup) => planGroup.countPlans),
              borderColor: this.planGroupBorderColor, // secondary
              borderWidth: 0.5,
              backgroundColor: this.planGroupBackgroundColors,
            },
          ],
        };
    },
    planGroupBorderColor() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return "#49a13e";
      }
      return "#522e91";
    },
    planGroupBackgroundColors() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return [
            "rgba(85, 185, 72, 0.8)",
            "rgba(85, 185, 72, 0.6)",
            "rgba(85, 185, 72, 0.3)",
            "rgba(85, 185, 72, 0.0)",
            "#cccccc",
            "rgba(85, 185, 72, 0.8)",
            "rgba(85, 185, 72, 0.6)",
            "rgba(85, 185, 72, 0.3)",
            "rgba(85, 185, 72, 0.0)",
            "#cccccc",
          ];
      }
      return ["#b9abd3", "#ff99d2", "#522e91", "#ff59d7", "#cccccc", "#b9abd3", "#ff99d2", "#522e91", "#ff59d7", "#cccccc"];
    },
  },
  created() {
    this.loadPlanCounts();
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    loadPlanCounts() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/plans-by-group`;

      this.$axios
        .get(url)
        .then((res) => {
          this.planCounts = res.data.results;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
